import { Link } from 'react-router-dom';
import type { SugestaoAposPresenca } from '../types';

interface Props {
  sugestao: SugestaoAposPresenca;
}

export default function CartaoSugestao({ sugestao }: Props) {
  const meta = [sugestao.quando, sugestao.onde].filter(Boolean).join(' · ');
  const destino = sugestao.link || (sugestao.slug ? `/e/${sugestao.slug}` : '/');

  return (
    <div className="overflow-hidden rounded-xl border border-secondary-200 bg-white">
      {sugestao.imagem && (
        <div className="relative aspect-[16/9] w-full overflow-hidden bg-secondary-100">
          <img
            src={sugestao.imagem}
            alt={sugestao.titulo ?? 'Evento'}
            title={`${sugestao.titulo ?? 'Evento'} — evento católico`}
            className="h-full w-full object-contain object-center"
          />
        </div>
      )}

      <div className="p-5">
        {sugestao.titulo && (
          <h3 className="text-lg font-semibold text-foreground-950">{sugestao.titulo}</h3>
        )}

        {meta && (
          <p className="mt-2 flex items-center gap-2 text-sm text-foreground-600">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-calendar-line" />
            </span>
            {meta}
          </p>
        )}

        {sugestao.a_partir_de && (
          <p className="mt-1 text-sm font-semibold text-foreground-900">
            a partir de {sugestao.a_partir_de}
          </p>
        )}

        {sugestao.texto && (
          <p className="mt-3 text-sm text-foreground-700">{sugestao.texto}</p>
        )}

        <Link
          to={destino}
          className="mt-5 flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-primary-600"
        >
          Ver ingressos
        </Link>
      </div>
    </div>
  );
}